<template>
  <pt-third-vendors-table class="pt-third-vendors-table__withData" @getTableData="getTableData" :tableData="tableData" :tableLabel="tableLabel" :totalNumber="totalNumber"
  ref="tableIndex" :isOutside="isOutside">
      <slot/>
  </pt-third-vendors-table>
</template>

<script>
import PtThirdVendorsTable from './index'
import { dataExport } from 'utils/formUtils'
export default {
  name: 'pt-third-vendors-table__withData',
  components: {
    'pt-third-vendors-table': PtThirdVendorsTable
  },
  props: {
    tableLabel: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isFromRouter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0,
      isOutside: false
    }
  },
  computed: {
    page () {
      return this.$refs.tableIndex.page
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (!this.isFromRouter) {
        //   this.getTableData(0)
          this.$refs.tableIndex.resetPage()
        } else {
          this.isOutside = true
          this.getTableData(this.page)
        }
      },
      deep: true
    }
  },
  methods: {
    getTableData (page, next) {
      let data = {
        ...this.paramsData,
        pageable: {
          page: page,
          size: this.pageSize
        }
      }
      this.$store.dispatch('getVendorsList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        console.log(this.tableData)
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$message.error(err || '获取第三方供应商列表失败')
      })
    },
    load () {
      // this.$nextTick(_ => {
      this.$refs.tableIndex.load()
      // })
    },
    toEduce () {
      let params = {
        ...this.paramsData,
        pageable: {
          page: 0,
          size: 999999
        }
      }
      this.$store.dispatch('exportVendors', params).then(res => {
        dataExport(res)
      }).catch(err => {
        this.$message(err || '导出失败')
      })
    }
  }
}
</script>
